import { HttpClient } from '@angular/common/http';
import { Component, HostListener, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import Editor from "../../../assets/js/ckeditor";
import { SnotifyService } from 'ng-snotify';
import { Config } from '../../config/config';
import { RestDataService } from '../../service/rest-data.service';
import { SharedDataService } from '../../service/shared-data.service';
import { StaticDataService } from '../../service/static-data.service';
import { CmsVideos } from './video-cms';
import { CmsVideoMasterDto } from './video-masterdata';
import { VideoMetadata } from './video-metadata';
import { cloneDeep } from 'lodash';
import { isEqual } from 'lodash';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';
import { GoogleAnalyticsService } from '../../service/google-analytics.service';

@Component({
  selector: 'app-video-cms',
  templateUrl: './video-cms.component.html',
  styleUrls: ['./video-cms.component.css']
})
export class VideoCmsComponent implements OnInit {
  public ckEditor2 = Editor;
  public ckEditor1 = Editor;
  addVideoPopup: boolean;
  addShortVideoPopup: boolean;
  ckTitle: String = null;
  ckYTTitle: String = null;
  ckDescription: String = null;
  ckYTDescription: String = null;
  longfile: File = null;
  shortfile: File = null;
  thumbnail: File = null;
  videoUploadError: string;
  showLoader: boolean;
  categoryQuery = '';
  filteredCategorySuggestion = [];
  languageQuery = '';
  filteredLanguageSuggestion = [];
  genreQuery = '';
  filteredGenreSuggestion = [];
  subGenreQuery = '';
  filteredSubGenreSuggestion = [];
  pChannelQuery = '';
  filteredpChannelSuggestion = [];
  sChannelQuery = '';
  playListQuery = '';
  filteredsChannelSuggestion = [];
  filteredsPlaylistSuggestion = [];
  playListSuggestion: any;
  inside = '';
  currentSelection = -1;
  primaryChannels = [];
  playlistChannels: any;
  playListError: string;
  secondaryChannels = [];
  selectedSecondaryChannels = [];
  selectedPlaylistChannels = [];
  selectedPlayListChannelValues = [];
  selectedSecondaryChannelValues = [];
  selectedLongVideoFile: File = null;
  selectedShortVideoFile: File = null;
  selectedThumbnailFile: File = null;
  requestBody = new FormData();
  uploadInProgress = false;
  id: any;
  videoIframeHtml: any = null;
  userId: String = null;
  locked = true;
  thumbnailLoaded = false;
  isLoading = true;
  imageSrc: any;
  primaryYTChannelId: string;
  videoSrc: any;
  autosave: any;
  autosavequeue = 0;
  subscription1: Subscription;
  playListStatus: any;
  status: boolean;
  descriptionEditor: any;
  ytDescriptionEditor: any;
  defaultDescription: String = "";
  titleEditor: any;
  ytTitleEditor: any;
  uploadOnYouTube: any;
  uploadOnSaranyu: any;
  enableSaranyu: boolean;
  @ViewChild('categoryList',{static: false}) categoryList;
  @ViewChild('genreList',{static: false}) genreList;
  @ViewChild('subGenreList',{static: false}) subGenreList;
  @ViewChild('languageList',{static: false}) languageList;
  @ViewChild('pChannelList',{static: false}) pChannelList;
  @ViewChild('sChannelList',{static: false}) sChannelList;
  @ViewChild('categoryInput',{static: false}) categoryInput;
  @ViewChild('longVideo',{static: false}) longVideo;
  @ViewChild('shortVideo',{static: false}) shortVideo;
  @ViewChild('thumbnailImage',{static: false}) thumbnailImage;
  @ViewChild('playList',{static: false}) playList;


  createMode = false;
  editMode = false;
  videoMetadata: VideoMetadata;
  savedVideoMetadata: VideoMetadata;
  videoCms: CmsVideos = null;
  videoMasterdata: CmsVideoMasterDto;
  allowspecialChar: string = StaticDataService.allowSpecialCharKeywordsTags;
  domainConfig = {};
  disabledMetaFields = [];
  enableKeywordsDrag = false;
  videoSize = 300;
  imageSize = 2;
  titleSize = 100;
  addThumbnailError: string;
  revertListFlag = false;
  topToggleOpen = true;  
  videoButtons = [];
  cksummaryconfig = {
    toolbar: [],
    link: {
      decorators: {
        isExternal: {
          mode: 'automatic',
          callback: url => url,
          attributes: {
            target: '_blank'
          }
        }
      }
    },
    disableTwoWayDataBinding: false
  };

  ckdesciptionconfig = {
    toolbar: [],
    link: {
      decorators: {
        isExternal: {
          mode: 'automatic',
          callback: url => url,
          attributes: {
            target: '_blank'
          }
        }
      }
    },
    disableTwoWayDataBinding: false
  };
  s3LongUrl: any;
  autoSaveVideoConvertor = false;
  constructor(private restService: RestDataService,
    private sharedService: SharedDataService,
    private snotify: SnotifyService,
    private http: HttpClient,
    private config: Config,
    private router: Router,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private gaService:GoogleAnalyticsService,
    private location: Location) {
    this.sharedService.getCurrentDomainConfig(this.getDomainConfig.bind(this));
    this.disabledMetaFields = (this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['disabledMeta']
      && this.domainConfig['config']['disabledMeta']['fields']) ? this.domainConfig['config']['disabledMeta']['fields'].split(',') : [];
    this.enableKeywordsDrag = this.sharedService.isdomainConfig('story', 'enableKeywordsDrag');
    this.videoSize = (this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['video']
      && this.domainConfig['config']['video']['maxsize']) ? +(this.domainConfig['config']['video']['maxsize']) : 300;
    this.imageSize = (this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['image']
      && this.domainConfig['config']['image']['maxsize']) ? +(this.domainConfig['config']['image']['maxsize']) : 2;
    this.titleSize = (this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['video']
      && this.domainConfig['config']['video']['titlesize']) ? +(this.domainConfig['config']['video']['titlesize']) : 100;
    this.id = this.route.snapshot.paramMap.get('id');
    this.userId = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))['user'].username;
    this.defaultDescription = (this.domainConfig && this.domainConfig['config'] && 
                    this.domainConfig['config']['story'] && this.domainConfig['config']['story']['defaultDescription'])?
                    this.domainConfig && this.domainConfig['config'] && 
                    this.domainConfig['config']['story'] && this.domainConfig['config']['story']['defaultDescription']:"";
    //this.getMasterData();
    this.snotify.clear();
    this.enableSaranyu = this.domainConfig['config']['story']['enableSaranyu'];

  }


  ngOnInit() {
    // this.uploadOnYouTube = true;
    // this.uploadOnSaranyu = true;
    if (this.id != null && this.id != undefined) {
      this.videoMetadata = new VideoMetadata();
      this.savedVideoMetadata = new VideoMetadata();
      this.videoMetadata.keywords = [];
      this.videoMetadata.topics = [];
      this.getMasterData();
      this.sharedService.sendData('publish_disable|true');
      this.sharedService.sendData('saves3_disable|true');
      // this.sharedService.sendData('publish_disable|false');
      //  this.getVideo();
      //  this.createMode = false;
      //  this.editMode = true;
    } else {
      this.locked = false;
      this.editMode = false;
      this.createMode = true;
      this.videoMetadata = new VideoMetadata();
      this.savedVideoMetadata = new VideoMetadata()
      this.savedVideoMetadata.keywords = [];
      this.savedVideoMetadata.topics = [];
      this.videoMetadata.keywords = [];
      this.videoMetadata.topics = [];
      this.getMasterData();
      this.sharedService.sendData('publish_disable|true');
      this.sharedService.sendData('saves3_disable|true');
      this.route.queryParams.subscribe(params => {
      this.showLoader = true;
         this.autoSaveVideoConvertor = true;
         this.s3LongUrl = params.aiVideoUrl;
        // this.videoCms.longVideoS3Url = params.aiVideoUrl;
        console.log("param",params)
      })
    }
    this.sharedService.sendData('saveFlag|false');
    sessionStorage.setItem('videoCmsId', this.id);
    sessionStorage.setItem('isLocked', JSON.stringify(this.locked));


    this.subscription1 = this.sharedService.getData().subscribe(x => {
      if (x === 'videoCmsPublish') {
        if (this.videoCms != null && this.videoCms != undefined) {
          if (this.videoCms.longVideoS3Url != null && (this.videoCms.ytPrimaryUploadStatus === 'NOTEXIST' || this.videoCms.ytPrimaryUploadStatus === 'FAILED')) {
            if (this.selectedLongVideoFile != null || this.selectedThumbnailFile != null) {
              let msg = "";
              if(this.selectedLongVideoFile != null && this.selectedThumbnailFile != null) {
                msg = "Selected video and thumbnail not uploaded to s3, do you still want to continue.";
              } else if (this.selectedLongVideoFile != null) {
                msg = "Selected video not uploaded to s3, do you still want to continue.";
              } else if (this.selectedThumbnailFile != null) {
                msg = "Selected thumbnail not uploaded to s3, do you still want to continue.";
              }
              const { timeout, closeOnClick, ...config } = this.sharedService.getConfig('lock');
              this.snotify.confirm(msg, '', {
                ...config,
                buttons: [
                  {
                    text: 'Yes', action: (toast) => {
                      this.snotify.remove(toast.id);
                      this.retryVideoUpload();
                      this.googleAnalytics("Skippable Alerts",msg,sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'Yes' , null);

                    }, bold: false
                  },
                  { text: 'No', action: (toast) => { this.snotify.remove(toast.id);
                    this.googleAnalytics("Skippable Alerts",msg,sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'No' , null);
                  } }
                ]
              });
            } else{
              this.retryVideoUpload();
            }
          }
          else if (this.videoCms.longVideoS3Url == null) {
            this.snotify.error("Please upload video to s3 first");
          }
          // if(this.videoCms.ytPrimaryUploadStatus === 'FAILED' && this.videoCms.longVideoS3Url != null)
          // {
          //   this.retryVideoUpload();
          // } else if(this.videoCms.ytPrimaryUploadStatus === 'FAILED' && this.videoCms.longVideoS3Url == null)
          // {
          //   this.done();
          // }
          // else if(this.videoCms.ytPrimaryUploadStatus === 'NOTEXIST' && this.videoCms.s3LongVideoUploadStatus === 'NOTEXIST')
          // {
          //   this.done();
          // } else if(this.videoCms.ytPrimaryUploadStatus === 'NOTEXIST' && this.videoCms.longVideoS3Url == null)
          // {
          //   this.done();
          // } 
          //     else if(this.videoCms.ytPrimaryThumbnailUpdateStatus === 'FAILED') {
          //       this.addThumbnailError = "Thumbnail upload failed. Please try again."
          //     } else if(this.videoCms.ytPrimaryThumbnailUploadStatus === 'FAILED') {
          //       this.addThumbnailError = "Thumbnail upload failed on YT. Please try again."
          //     } else if(this.videoCms.s3ThumbnailUploadStatus === 'FAILED') {
          //       this.addThumbnailError = "Thumbnail upload failed on S3. Please try again."
          //     } else if(this.videoCms.ytPrimaryUpdateStatus === 'FAILED') {
          //       this.videoUploadError = "Video upload failed. Please try again."
          //     } else if(this.videoCms.ytPrimaryUploadStatus === 'FAILED') {
          //       this.videoUploadError = "Video upload failed on YT. Please try again."
          //     } else if(this.videoCms.s3LongVideoUploadStatus === 'FAILED') {
          //       this.videoUploadError = "Video upload failed on S3. Please try again."
          // } 
          else {
            if(this.videoCms['saranyuUploadStatus'] === 'NOTEXIST' && this.uploadOnSaranyu === true){
              this.retryVideoUpload();
            }
            else if(this.videoCms['ytPrimaryUploadStatus'] === 'NOTEXIST' && this.uploadOnYouTube === true) {
              this.retryVideoUpload();
            } 
            else {
              if(this.videoCms['saranyuUploadStatus'] === 'PUBLISHED' && this.uploadOnSaranyu === true){
                this.router.navigate(['/dash/video-cms-list']);
              } else {
                this.edit();
              }
            }
          }
        } else {
          this.snotify.error("Please set video title, decription and metadata first");
        }
      }
      else if (x === 'video-cms-save') {
        this.autoSaveMetaData(false);
      }
      else if (x === 'video-cms-save-s3') {
        //this.autoSaveMetaData(false);
        this.saveToS3();
      }
    });
    //this.getMasterData();
  }

  ngOnDestroy() {
    this.destroyAutoSave();
    this.subscription1.unsubscribe();
  }

  ckEditorReadOnlyDisabled() {
    if(this.descriptionEditor && this.locked){
      this.descriptionEditor.enableReadOnlyMode('editor');
    } 
    if(this.ytDescriptionEditor && this.locked) {
      this.ytDescriptionEditor.enableReadOnlyMode('editor')
    }
    if(this.titleEditor && this.locked){
      this.titleEditor.enableReadOnlyMode('editor');
    } 
    if(this.ytTitleEditor && this.locked){
      this.ytTitleEditor.enableReadOnlyMode('editor');
    } 
    if(this.descriptionEditor && !this.locked) {
      this.descriptionEditor.disableReadOnlyMode('editor')
    }
    if(this.ytDescriptionEditor && !this.locked) {
      this.ytDescriptionEditor.disableReadOnlyMode('editor')
    }
    if(this.titleEditor && !this.locked) {
      this.titleEditor.disableReadOnlyMode('editor')
    }
    if(this.ytTitleEditor && !this.locked) {
      this.ytTitleEditor.disableReadOnlyMode('editor')
    }
  }

  ckchanges(ev, label, model) {
    if (label === 'ready') {
      switch (model) {
        case 'desc':
          this.descriptionEditor = ev;
          if(this.id==null){
            this.descriptionEditor.setData(this.defaultDescription);
          }
          break;
        case 'descYT':
          this.ytDescriptionEditor = ev;
          if(this.id==null){
            this.ytDescriptionEditor.setData(this.defaultDescription);
          }
        break;
        case 'title':
          this.titleEditor = ev;
          break;
        case 'yttitle':
          this.ytTitleEditor = ev;
          break;
        default: break;
      }
    }
    if(label === 'change'){
      switch (model) {
        case 'desc':
          if(this.descriptionEditor){
            this.checkingHyperlinkValid(this.descriptionEditor,model,this.ckDescription)
            this.ckYTDescription =  this.videoMetadata.ytDescription!==  this.videoMetadata.videoDescription ?  this.videoMetadata.ytDescription: this.ckDescription;
          }
          break;
        case 'title':
          if(this.titleEditor){
            this.checkingHyperlinkValid(this.titleEditor,model,this.ckTitle)
            this.ckYTTitle = this.videoMetadata.ytTtile !==  this.videoMetadata.videoTitle ? this.videoMetadata.ytTtile : this.ckTitle;
          }
          break;
        case 'descYT':
          if(this.ytDescriptionEditor){
            this.checkingHyperlinkValid(this.ytDescriptionEditor,model,this.ckYTDescription)
          }
          break;
        case 'yttitle':
          if(this.ytTitleEditor){
            this.checkingHyperlinkValid(this.ytTitleEditor,model,this.ckYTTitle)
          }
          break;
        default: break;
      }
    }
    this.ckEditorReadOnlyDisabled();
  }

  setYoutube($event){
    this.uploadOnYouTube = !this.uploadOnYouTube;
    this.videoMetadata.ytUpload = this.uploadOnYouTube;
    if(this.videoCms.longVideoS3Url != null && this.videoCms.longVideoS3Url != ''){
      if(this.uploadOnSaranyu === false && this.uploadOnYouTube === false){
        this.sharedService.sendData('publish_disable|true');
      } else {
        this.sharedService.sendData('publish_disable|false');
      }
    }
  }

  setSaranyu($event){
    this.uploadOnSaranyu = !this.uploadOnSaranyu;
    this.videoMetadata.saranyuUpload = this.uploadOnSaranyu;
    if(this.videoCms.longVideoS3Url != null && this.videoCms.longVideoS3Url != ''){
    if(this.uploadOnSaranyu === false && this.uploadOnYouTube === false){
      this.sharedService.sendData('publish_disable|true');
    } else {
      this.sharedService.sendData('publish_disable|false');
    }
  }
  }

  checkingHyperlinkValid(editor,type,data) {
    if(editor && editor.model) {
      const doc = editor.model.document;
      const selection = doc.selection;
      const range = selection.getFirstRange();
      let selectedWord;
      for (const item of range.getItems()) {
        selectedWord = item.data;
    }
      let docStr = (JSON.stringify(doc));
      if(JSON.parse(docStr)['differ']['_cachedChanges'][0]['attributeKey'] === 'linkHref'){
        let hrefUrl = this.sharedService.extractHrefUrl(editor);
          if(hrefUrl !== undefined && hrefUrl !== null) {
            let allLink =  this.sharedService.findInvalidLinkWord(editor);
            let matchLinkObj = allLink.filter(e =>e.href===hrefUrl)
            const validLink = this.checkUrlValidate(hrefUrl,data,type,editor);
            if(validLink){
              this.restService.http_get(this.config.get('product').utilUrl + '/api/cms/validate/link/?url='+hrefUrl)
              .subscribe((response) => {
              if(response.statusCode === 200){
              } else {
              setTimeout(e4 => {
                if(editor) {
                  this.getremoveInvalidLink(data,matchLinkObj[0].linkText,type,editor)
                }
              }, 1000); 
              this.snotify.error('Link is invalid', '', this.sharedService.getConfig(false));
            }
          },error=>{
            setTimeout(e4 => {
              if(editor) {
                this.getremoveInvalidLink(data,matchLinkObj[0].linkText,type,editor)
              }
            }, 1000); 
            this.snotify.error('Link is invalid', '', this.sharedService.getConfig(false));
            })
          
          }
          }
      }
    }
     else {
      return true;
    }
  }

  checkUrlValidate(url,data,type,editor) {
    var urlValid = /[a-z0-9-]*\.?[a-z0-9-]+\.[a-z0-9-]+\.?[a-z0-9-]+(\/[^<>]*)?$/;
    let allLink =  this.sharedService.findInvalidLinkWord(editor);
    let matchLinkObj = allLink.filter(e =>e.href===url)
    if(urlValid.test(url) === false) {
       this.snotify.info('Please enter valid URL', '', this.sharedService.getConfig(false));
       setTimeout(e4 => {
         if(editor) {
           this.getremoveInvalidLink(data,matchLinkObj[0].linkText,type,editor)
         }
       }, 1000);
     } else if(!url.startsWith('https')) {
       this.snotify.error('Link is invalid,link should be start with https.Please enter valid link.', '', this.sharedService.getConfig(false));
       setTimeout(e4 => {
         if(editor) {
           this.getremoveInvalidLink(data,matchLinkObj[0].linkText,type,editor)
         }
       }, 1000);    
     }
     return urlValid.test(url) && url.startsWith('https') ;
  }

  getremoveInvalidLink(cardData,word,type,editor){
    let paraBody=cardData;
      if(!!word && !!cardData){
        let replaceThis = '<a[^>]*>'+word+'<\/a>'
        let regexReplace = new RegExp(`${replaceThis}`)
        let l = regexReplace.exec(paraBody);
        if(!!l && l.length>0){
          paraBody = paraBody.replace(regexReplace, word);
          cardData= paraBody;
          editor ? editor.setData(cardData):'';
        }
      }
  }
  
  generateAutoSave() {
    console.log("videoMetadata",this.videoMetadata)
    this.autosave = setInterval(() => {
      this.autoSaveMetaData(true);
    }, 1500);
  }

  checkAutoSaveNeeded() {
    if (!this.assignTitleAnddescription()) {
      return false;
    }
    if (this.savedVideoMetadata == null && this.videoMetadata != null) {
      if (!isEqual(this.videoMetadata, new VideoMetadata())) {
        return true;
      }
    }
    else if (this.videoMetadata == null && this.savedVideoMetadata != null) {
      if (!isEqual(new VideoMetadata(), this.savedVideoMetadata)) {
        return true;
      }
    }
    else if (this.videoMetadata != null && this.savedVideoMetadata != null) {
      if (!isEqual(this.videoMetadata, this.savedVideoMetadata)) {
        return true;
      }
    }
    if(this.autoSaveVideoConvertor){
      this.autoSaveVideoConvertor = false;
      return true;
    }
    return false;
  }

  autoSaveMetaData(flag) {
    if (this.checkAutoSaveNeeded() && this.autosavequeue == 0) {
      if (!flag) {
        this.isLoading = true;
      }
      this.autosavequeue++;
      this.sharedService.sendData('saveFlag|true');
      if (this.id != null) {
        this.http.post(this.config.get('product').videoCmsUrl + "/api/cms/video/autosave" + "?id=" + this.id, JSON.stringify(this.videoMetadata)).subscribe(res => {
          if (res != null) {
            // this.isLoading = false;
            this.savedVideoMetadata = cloneDeep(this.videoMetadata);
            if (!flag) {
              this.snotify.info("Saved successfully");
            }
          } else if (!flag) {
            this.snotify.error("Failed to save");
          }
          this.autosavequeue--;
          this.sharedService.sendData('saveFlag|false');
          if (!flag) {
            this.isLoading = false;
          }
          sessionStorage.setItem('videoCmsStatus', JSON.stringify(this.videoCms.cmsVideoStatus));
        },
          err => {
            //this.isLoading = false;
            if (!flag) {
              this.isLoading = false;
            }
            this.autosavequeue--;
            this.snotify.error("Auto save failed");
            this.sharedService.sendData('saveFlag|false');
            this.destroyAutoSave();
            this.router.navigate(['/dash/video-cms-list']);
          });
      } else { 
        this.videoMetadata.ytUpload = true;
        if(this.enableSaranyu){
          this.videoMetadata.saranyuUpload = true
        } else {
          this.videoMetadata.saranyuUpload = false;
        }
        console.log("this.videoMetadata",this.videoMetadata)
        // this.videoMetadata.videoDescription = this.ckDescription==null?this.descriptionEditor.getData():this.ckDescription;
        // this.videoMetadata.ytDescription =  this.ckYTDescription==null? this.ytDescriptionEditor.getData() : this.ckYTDescription;
        this.ckDescription = this.ckDescription==null?this.descriptionEditor.getData():this.ckDescription;
        // this.ckYTDescription = this.ckYTDescription==null? this.ytDescriptionEditor.getData() : this.ckYTDescription;
        this.http.post(this.config.get('product').videoCmsUrl + "/api/cms/video/autosave", JSON.stringify(this.videoMetadata)).subscribe(res => {
          if (res != null) {
            //this.isLoading = false;
            this.id = res['id'];
            sessionStorage.setItem('videoCmsId', this.id);
            this.videoCms = cloneDeep(res);
            this.location.replaceState('/dash/story/' + res['id']);
            this.savedVideoMetadata = cloneDeep(this.videoMetadata);
            if((this.videoCms.longVideoS3Url == null || this.videoCms.longVideoS3Url == undefined) && this.videoCms.isDeleted == 0)
            {
              this.videoButtons = [];
              this.videoButtons.push({displayName: 'Discard Video',
                methodName: 'deleteCurrentVideo',
                functionType: 'button',
                id: 'discardVideo'
              })
            }
            if (!flag) {
              this.snotify.info("Saved successfully");
            }
            if(this.s3LongUrl){
              this.updateS3LongUrl();
              this.s3LongUrl = '';
            }
            this.videoMetadata.unlisted = true;
            sessionStorage.setItem('videoCmsStatus', JSON.stringify(this.videoCms.cmsVideoStatus));
            setTimeout(() => {
              this.showLoader = false;
            }, 2000);
            // this.sharedService.sendData('publish_disable|false');
            // this.snotify.info("Upload request sent successfully");
            // this.router.navigate(['/dash/video-cms-list']);
          } else if (!flag) {
            this.snotify.error("Failed to save");
          }
          this.autosavequeue--;
          this.sharedService.sendData('saveFlag|false');
          if (!flag) {
            this.isLoading = false;
          }
        },
          err => {
            //this.isLoading = false;
            if (!flag) {
              this.isLoading = false;
            }
            this.autosavequeue--;
            this.snotify.error("Auto save failed");
            this.sharedService.sendData('saveFlag|false');
            this.destroyAutoSave();
            this.router.navigate(['/dash/video-cms-list']);
          });
      }
    } else if (!flag) {
      this.snotify.error("Please do some changes in video title, description and metadata before saving");
    }
  }

  destroyAutoSave() {
    if (this.autosave) {
      clearInterval(this.autosave);
      this.autosave = null;
    }
  }

  getDomainConfig(currentDomainConfig) {
    this.domainConfig = currentDomainConfig;
  }

  imgLoaded(event) {
    this.thumbnailLoaded = true;
  }

  getVideo() {
    this.http.get(this.config.get('product').videoCmsUrl
      + "/api/cms/video/" + this.id).subscribe((response: CmsVideos) => {
        if (response) {
          this.videoCms = cloneDeep(response);
          this.playListStatus = this.videoCms.playListStatus;
          sessionStorage.setItem('videoCmsStatus', JSON.stringify(this.videoCms.cmsVideoStatus));

          if((this.videoCms.longVideoS3Url == null || this.videoCms.longVideoS3Url == undefined) && this.videoCms.isDeleted == 0)
          {
            this.videoButtons = [];
            this.videoButtons.push({displayName: 'Discard Video',
            methodName: 'deleteCurrentVideo',
            functionType: 'button',
            id: 'discardVideo'
        })
          }
          this.status = this.videoCms.ytPrimaryUploadStatus === 'NOTEXIST' || this.videoCms.s3LongVideoUploadStatus === 'FAILED' ? false : true;
          if (response.cmsVideoMetadata != null && response.cmsVideoMetadata != undefined) {
            this.videoMetadata = cloneDeep(response.cmsVideoMetadata);
            this.savedVideoMetadata = cloneDeep(response.cmsVideoMetadata);
            console.log("this.videoMetadata",this.videoMetadata.ytUpload,this.videoMetadata.saranyuUpload)
            if (this.videoMetadata != null && this.videoMetadata != undefined) {
              this.ckTitle = this.videoMetadata.videoTitle ? this.videoMetadata.videoTitle : '';
              this.ckDescription = this.videoMetadata.videoDescription ? this.videoMetadata.videoDescription : '';
              this.ckYTTitle = this.videoMetadata.ytTtile ? this.videoMetadata.ytTtile : '';
              this.ckYTDescription = this.videoMetadata.ytDescription ? this.videoMetadata.ytDescription : '';
              this.videoMetadata.ytUpload!=null ? this.uploadOnYouTube = this.videoMetadata.ytUpload : this.uploadOnYouTube = true;
              this.videoMetadata.saranyuUpload!=null ? this.uploadOnSaranyu = this.videoMetadata.saranyuUpload :this.uploadOnSaranyu = true;
              // this.videoMetadata.ytUpload =  this.uploadOnYouTube;
              // this.videoMetadata.saranyuUpload = this.uploadOnSaranyu;
              if (this.videoMetadata.videoGenre != null) {
                for (let a of this.videoMasterdata.genres) {
                  if (a.value == this.videoMetadata.videoGenre) {
                    this.genreQuery = a.key;
                    break;
                  }
                }
              }
              if (this.videoMetadata.videoSubGenre != null) {
                for (let a of this.videoMasterdata.subGenres[this.videoMetadata.videoGenre.toString()]) {
                  if (a.value == this.videoMetadata.videoSubGenre) {
                    this.subGenreQuery = a.key;
                    break;
                  }
                }
              }
              if (this.videoMetadata.videoCategory != null) {
                for (let a of this.videoMasterdata.categories) {
                  if (a.value == this.videoMetadata.videoCategory) {
                    this.categoryQuery = a.key;
                    break;
                  }
                }
              }
              if (this.videoMetadata.videoLanguage != null) {
                for (let a of this.videoMasterdata.languages) {
                  if (a.value == this.videoMetadata.videoLanguage) {
                    this.languageQuery = a.key;
                    break;
                  }
                }
              }
              if (this.videoMetadata.primaryChannel != null) {
                for (let a of this.videoMasterdata.channels) {
                  if (a.value == this.videoMetadata.primaryChannel) {
                    this.pChannelQuery = a.key;
                    break;
                  }
                }
              }
              if (this.videoMetadata.secondaryChannels != null) {
                this.primaryChannels = this.videoMasterdata.channels.filter(function (el) {
                  return !this.videoMetadata.secondaryChannels.includes(el.value);
                }.bind(this));
                this.selectedSecondaryChannels = [];
                this.selectedSecondaryChannelValues = [];
                this.videoMasterdata.channels.forEach((el) => {
                  if (this.videoMetadata.secondaryChannels.includes(el.value)) {
                    this.selectedSecondaryChannels.push(el);
                    this.selectedSecondaryChannelValues.push(el.value);
                  }
                })
              }
              if (this.videoMetadata.playlists != null && this.videoMetadata.playlists.length > 0) {
                this.selectedPlaylistChannels = [];
                this.selectedPlayListChannelValues = [];
                for (const [key, value] of Object.entries(this.playlistChannels)) {
                  if (key === response.cmsVideoMetadata.primaryChannel) {
                    this.primaryYTChannelId = key;
                    this.playListSuggestion = value;
                  }
                }
                this.selectedPlayListChannelValues = this.videoMetadata.playlists;
                this.playListSuggestion.forEach(e => {
                  if (this.videoMetadata.playlists.includes(e.value)) {
                    this.selectedPlaylistChannels.push(e)
                  }
                })
                this.checkPlayListStatus();
              }
              if (this.videoMetadata.primaryChannel != null) {
                this.secondaryChannels = this.videoMasterdata.channels.filter(function (el) {
                  return !this.videoMetadata.primaryChannel.includes(el.value);
                }.bind(this));
              }
            }
          }
          if (response.primaryYoutubeVideo != null && response.primaryYoutubeVideo.standardEmbedCode != null) {
            this.videoIframeHtml = this.makeRenderable(cloneDeep(response.primaryYoutubeVideo.standardEmbedCode));
          }
          if (this.videoCms.cmsVideoStatus == 'INPROGRESS') {
            const { timeout, closeOnClick, ...config } = this.sharedService.getConfig('lock');
            this.snotify.confirm('Some action is in progress, please Reload after some time.', '', {
              ...config,
              buttons: [
                {
                  text: 'Reload', action: (toast) => {
                    this.snotify.remove(toast.id);
                    this.getVideo();
                  }, bold: false
                },
                { text: 'Cancel', action: (toast) => { this.snotify.remove(toast.id); } }
              ]
            });
          }
          else if(this.videoCms.lockedByUserId === null){
            this.unlockStory();
          }
          else if (this.videoCms.lockedByUserId != this.userId) {
            const { timeout, closeOnClick, ...config } = this.sharedService.getConfig('lock');
            this.snotify.confirm('Locked by ' + this.videoCms.lockedByUserName + ', Unlock?', '', {
              ...config,
              buttons: [
                {
                  text: 'Yes', action: (toast) => {
                    this.snotify.remove(toast.id);
                    this.unlockStory();
                    this.googleAnalytics("Skippable Alerts",'Locked by ' + this.videoCms.lockedByUserName + ', Unlock?',sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'Yes' , null);
                  }, bold: false
                },
                { text: 'No', action: (toast) => { this.snotify.remove(toast.id);
                  this.googleAnalytics("Skippable Alerts",'Locked by ' + this.videoCms.lockedByUserName + ', Unlock?',sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'No' , null);
                } }
              ]
            });
          } else {
            this.locked = false;
            sessionStorage.setItem('isLocked', JSON.stringify(this.locked));
            this.ckEditorReadOnlyDisabled();
          }
          if (this.videoCms.ytPrimaryUploadStatus == 'NOTEXIST') {
            this.createMode = true;
            this.editMode = false;
          } else {
            this.createMode = false;
            this.editMode = true;
          }
          if (this.videoCms.longVideoS3Url != null && this.videoCms.longVideoS3Url != '' && (this.uploadOnSaranyu === true || this.uploadOnYouTube === true)) {
            this.sharedService.sendData('publish_disable|false');
          }
          this.isLoading = false;
          this.generateAutoSave();
          if (this.videoCms.ytPrimaryThumbnailUpdateStatus === 'FAILED') {
            this.addThumbnailError = "Thumbnail upload failed. Please try again."
          } else if (this.videoCms.ytPrimaryThumbnailUploadStatus === 'FAILED') {
            this.addThumbnailError = "Thumbnail upload failed on YT. Please try again."
          } else if (this.videoCms.s3ThumbnailUploadStatus === 'FAILED') {
            this.addThumbnailError = "Thumbnail upload failed on S3. Please try again."
          } else if (this.videoCms.ytPrimaryUpdateStatus === 'FAILED') {
            this.videoUploadError = "Video upload failed. Please try again."
          } else if (this.videoCms.ytPrimaryUploadStatus === 'FAILED') {
            this.videoUploadError = "Video upload failed on YT. Please try again."
          } else if (this.videoCms.s3LongVideoUploadStatus === 'FAILED') {
            this.videoUploadError = "Video upload failed on S3. Please try again."
          }
        }
      }, (error) => {
        console.log(error);
        this.snotify.error('Error While fetching Master data', '', this.sharedService.getConfig(false));
      });
  }

  checkPlayListStatus() {
    let failedStatus = false;
    this.selectedPlaylistChannels.forEach(e => {
      if (this.playListStatus) {
        for (const [key, value] of Object.entries(this.playListStatus)) {
          if (key === e.value && value === 'ADD_FAILED') {
            if (!failedStatus) {
              this.playListError = 'The video is not added on below playlists.\n';
              failedStatus = true;
            }
            this.playListError += '• ' + e.key + '\n';
          }
        }
      }
    })
  }

  unlockStory() {
    this.http.put(this.config.get('product').videoCmsUrl
      + "/api/cms/video/lock/" + this.id, null).subscribe((response: CmsVideos) => {
        if (response && response.lockedByUserId == this.userId) {
          this.locked = false;
          sessionStorage.setItem('isLocked', JSON.stringify(this.locked));
          this.ckEditorReadOnlyDisabled();
        } else {
          this.snotify.error('Failed to unlock video', '', this.sharedService.getConfig(false));
        }
      }, (error) => {
        console.log(error);
        this.snotify.error('Error While unlocking video', '', this.sharedService.getConfig(false));
      });
  }
  makeRenderable(text) {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }


  getMasterData() {
    this.http.get(this.config.get('product').videoCmsUrl
      + "/api/cms/video/getMasterData").subscribe((response: CmsVideoMasterDto) => {
        if (response) {
          this.videoMasterdata = response;
          this.primaryChannels = [...response.channels];
          this.secondaryChannels = [...response.channels];
          this.playlistChannels = response.playlists;
          // response.channels.forEach(el=>{
          //   //this.secondaryChannels.push({'itemName':el.key,'id':el.value});
          //   this.secondaryChannels.push(el.key)
          // })
          this.resetFilteredData();
          this.isLoading = false;
        }
        if (this.id != null) {
          this.getVideo();
        } else {
          this.uploadOnSaranyu = true;
          this.uploadOnYouTube = true;
          this.generateAutoSave();
        }
      }, (error) => {
        this.isLoading = false;
        console.log(error);
        this.snotify.error('Error While fetching Master data', '', this.sharedService.getConfig(false));
      });
  }

  resetFilteredData() {
    this.filteredCategorySuggestion = [];
    this.filteredLanguageSuggestion = [];
    this.filteredGenreSuggestion = [];
    this.filteredSubGenreSuggestion = [];
    this.filteredpChannelSuggestion = [];
    this.filteredsChannelSuggestion = [];
    this.filteredsPlaylistSuggestion = [];
  }

  addVideo() {
    //this.addVideoPopup= true;
    document.getElementById('longFile').click();
  }

  addSortVideo() {
    //this.addShortVideoPopup= true;
    document.getElementById('shortFile').click();
  }

  addThumbnail() {
    document.getElementById('thumbnailFile').click();
  }

  disableshowGallery() {
    this.addVideoPopup = false;
    this.addShortVideoPopup = false;
  }

  edit() {
    // this.editMode = true;
    console.log(this.ckTitle);
    console.log(this.ckDescription);
    this.assignTitleAnddescription();
    if (this.checkMandatoryFields() && this.autosavequeue == 0) {
      this.setRequestBody();
      this.requestBody.append('metaUpdated', "true");
      // this.requestBody.append('ytUpload',this.uploadOnYouTube)
      this.isLoading = true;
      this.autosavequeue++;
      //this.sharedService.sendData('publish_disable|true');
      let setStatusBody = this.getStatusBody("update");
      this.http.post(this.config.get('product').videoCmsUrl + "/api/cms/video/setStatus", setStatusBody).subscribe(res => {
        if (res != null) {
          this.sharedService.sendVideoData(this.config.get('product').videoCmsUrl + "/api/cms/video/update/"+ this.id, this.requestBody, setStatusBody);
          this.isLoading = false;
          this.snotify.info("Update request sent successfully");
          //this.sharedService.sendData('publish_disable|false');
          this.autosavequeue--
          this.router.navigate(['/dash/video-cms-list']);
        }
      },
        err => {
          this.isLoading = false;
          this.autosavequeue--;
          this.snotify.error("Update request failed");
          //this.sharedService.sendData('publish_disable|false');
        });
    }
  }

  done() {
    console.log(this.ckTitle);
    console.log(this.ckDescription);
    this.assignTitleAnddescription();
    if (this.checkMandatoryFields() && this.autosavequeue == 0) {
      this.setRequestBody();
      this.isLoading = true;
      this.autosavequeue++;
      //this.sharedService.sendData('publish_disable|true');
      let setStatusBody = this.getStatusBody("upload");
      this.http.post(this.config.get('product').videoCmsUrl + "/api/cms/video/setStatus", setStatusBody).subscribe(res => {
        if (res != null) {
          this.sharedService.sendVideoData(this.config.get('product').videoCmsUrl + "/api/cms/video/upload", this.requestBody, setStatusBody);
          this.isLoading = false;
          this.snotify.info("Upload request sent successfully");
          //this.sharedService.sendData('publish_disable|false');
          this.autosavequeue--;
          this.router.navigate(['/dash/video-cms-list']);
        }
      },
        err => {
          this.isLoading = false;
          this.autosavequeue--;
          this.snotify.error("Upload request failed");
          //this.sharedService.sendData('publish_disable|false');
        });
    }
  }

  saveToS3() {
    console.log(this.ckTitle);
    console.log(this.ckDescription);
    //this.assignTitleAnddescription();
    // if (this.checkMandatoryFields() && this.autosavequeue == 0) {
    this.setRequestBody();
    this.isLoading = true;
    this.autosavequeue++;
    //this.sharedService.sendData('publish_disable|true');
    let setStatusBody = this.getStatusBody("s3Upload");
    this.http.post(this.config.get('product').videoCmsUrl + "/api/cms/video/setStatus", setStatusBody).subscribe(res => {
      if (res != null) {
        this.sharedService.sendVideoData(this.config.get('product').videoCmsUrl + "/api/cms/video/uploadToS3", this.requestBody, setStatusBody);
        this.isLoading = false;
        sessionStorage.setItem('CmsStatus', JSON.stringify(true));
        this.snotify.info("S3 Upload request sent successfully");
        //this.sharedService.sendData('publish_disable|false');
        this.autosavequeue--;
        this.router.navigate(['/dash/video-cms-list']);
      }
    },
      err => {
        this.isLoading = false;
        this.autosavequeue--;
        this.snotify.error("s3 Upload request failed");
        //this.sharedService.sendData('publish_disable|false');
      });
    // }
  }

  updateS3LongUrl() {
    console.log(this.ckTitle);
    console.log(this.ckDescription);
    this.setRequestBodyS3LongUrlUpdate();
    this.isLoading = true;
    this.autosavequeue++;
    //this.sharedService.sendData('publish_disable|true');
    let setStatusBody = this.getStatusBody("s3Upload");
    this.http.post(this.config.get('product').videoCmsUrl + "/api/cms/video/setStatus", setStatusBody).subscribe(res => {
      if (res != null) {
        this.sharedService.sendVideoData(this.config.get('product').videoCmsUrl + "/api/cms/video/uploadToS3ByUrl", this.requestBody, setStatusBody);
        this.isLoading = false;
        sessionStorage.setItem('CmsStatus', JSON.stringify(true));
        this.videoCms = cloneDeep(res);
        this.getMasterData();
        this.autosavequeue--;
      }
    },
      err => {
        this.isLoading = false;
        this.autosavequeue--;
        this.snotify.error("s3 update request failed");
        //this.sharedService.sendData('publish_disable|false');
      });
    // }
  }

  setRequestBodyS3LongUrlUpdate() {
    if (this.s3LongUrl != null) {
      this.requestBody.append('longfile', this.s3LongUrl);
    }
    if (this.id != null) {
      this.requestBody.append('id', this.id)
    }
    if (this.videoMetadata != null) {
      this.requestBody.append('metadata', JSON.stringify(this.videoMetadata));
    }

  }

  retryVideoUpload() {
    this.assignTitleAnddescription();
    if (this.checkMandatoryFields() && this.autosavequeue == 0) {
      this.isLoading = true;
      this.autosavequeue++;
      let setStatusBody = new FormData();
      if (this.id != null) {
        setStatusBody.append('id', this.id)
      }
      setStatusBody.append('type', "retryUpload");
      console.log("setStatusBody",setStatusBody)
      this.http.post(this.config.get('product').videoCmsUrl + "/api/cms/video/setStatus", setStatusBody).subscribe(res => {
        if (res != null) {
          this.sharedService.retryVideoData(this.config.get('product').videoCmsUrl + "/api/cms/video/retry/upload/" + this.id, null, setStatusBody);
          this.isLoading = false;
          this.snotify.info("Upload request sent successfully");
          this.autosavequeue--;
          this.router.navigate(['/dash/video-cms-list']);
        }
      },
        err => {
          this.isLoading = false;
          this.autosavequeue--;
          this.snotify.error("Upload request failed");
        });
    }
  }

  getStatusBody(type: string) {
    let setStatusBody = new FormData();
    if (this.selectedLongVideoFile != null) {
      setStatusBody.append('longfile', "true");
    }
    if (this.selectedShortVideoFile != null) {
      setStatusBody.append('shortfile', "true");
    }
    if (this.selectedThumbnailFile != null) {
      setStatusBody.append('thumbnail', "true");
    }
    if (this.id != null) {
      setStatusBody.append('id', this.id)
    }
    if (this.videoMetadata != null && (this.createMode || this.editMode)) {
      setStatusBody.append('metadata', JSON.stringify(this.videoMetadata));
    }
    if (type != null) {
      setStatusBody.append('type', type);
    }
    return setStatusBody;
  }

  checkMandatoryFields() {
    if (this.videoMetadata == null || this.videoMetadata == undefined) {
      this.snotify.error("Video metadata is mandatory");
      return false;
    }
    if (this.videoMetadata.videoTitle == null || this.videoMetadata.videoTitle == undefined || this.videoMetadata.videoTitle.trim().length == 0) {
      this.snotify.error("Video title is mandatory");
      return false;
    }
    if (this.videoMetadata.videoDescription == null || this.videoMetadata.videoDescription == undefined || this.videoMetadata.videoDescription.trim().length == 0) {
      this.snotify.error("Video description is mandatory");
      return false;
    }
    // if (this.videoMetadata.videoGenre == null || this.videoMetadata.videoGenre == undefined || this.videoMetadata.videoGenre.trim().length == 0) {
    //   this.snotify.error("Video genre is mandatory");
    //   return false;
    // }
    // if (this.videoMetadata.videoSubGenre == null || this.videoMetadata.videoSubGenre == undefined || this.videoMetadata.videoSubGenre.trim().length == 0) {
    //   this.snotify.error("Video sub genre is mandatory");
    //   return false;
    // }
    if ((this.videoMetadata.videoCategory == null || this.videoMetadata.videoCategory == undefined || this.videoMetadata.videoCategory.trim().length == 0) && this.uploadOnYouTube === true) {
      this.snotify.error("Video category is mandatory");
      return false;
    }
    // if (this.videoMetadata.videoLanguage == null || this.videoMetadata.videoLanguage == undefined || this.videoMetadata.videoLanguage.trim().length == 0) {
    //   this.snotify.error("Video language is mandatory");
    //   return false;
    // }
    if ((this.videoMetadata.primaryChannel == null || this.videoMetadata.primaryChannel == undefined || this.videoMetadata.primaryChannel.trim().length == 0) && this.uploadOnYouTube === true) {
      this.snotify.error("Video primary channel is mandatory");
      return false;
    }
    //if (this.createMode && this.selectedLongVideoFile == null) {
    if (this.createMode && this.id != null && this.videoCms.longVideoS3Url == null) {
      this.snotify.error("Adding video is mandatory");
      return false;
    }
    return true;
  }

  assignTitleAnddescription() {
    if (this.ckTitle != null) {
      this.ckTitle === ''?  this.videoMetadata.videoTitle = this.htmlToPlaintext(null) : this.videoMetadata.videoTitle = this.htmlToPlaintext(this.ckTitle);
    }
    if (this.ckDescription != null) {
      this.ckDescription === ''? this.videoMetadata.videoDescription = this.htmlToPlaintext(null) : this.videoMetadata.videoDescription = this.htmlToPlaintext(this.ckDescription);
    }
    if (this.ckYTDescription != null) {
      this.ckDescription === ''? this.videoMetadata.ytDescription = this.htmlToPlaintext(null) : this.videoMetadata.ytDescription = this.htmlToPlaintext(this.ckYTDescription);
    }
    if(this.ckYTTitle!=null){
      this.ckTitle === ''?  this.videoMetadata.ytTtile = this.htmlToPlaintext(null) : this.videoMetadata.ytTtile = this.htmlToPlaintext(this.ckYTTitle);
    }
    if (this.videoMetadata.videoTitle != null && this.videoMetadata.videoTitle.trim().length > this.titleSize) {
      this.snotify.error("Video title should be less than " + this.titleSize + " char");
      return false;
    }
    return true;
  }

  htmlToPlaintext(text) {
    if (typeof text === 'string') {
      return text ? this.htmlSpecialCharToText(String(text).replace(/<[^>]+>/gm, '')) : '';
    } else {
      return text;
    }
  }

  htmlSpecialCharToText(text) {
    const translate_re = /&(nbsp|amp|quot|lt|gt);/g;
    const translate = {
      'nbsp': ' ',
      'amp': '&',
      'quot': '\'',
      'lt': '<',
      'gt': '>'
    };
    return (text.replace(translate_re,
      (match, entity) => {
        return translate[entity];
      })
    );
  }

  specialCharBlock(e) {
    if (e.which < 48 ||
      (e.which > 57 && e.which < 65) ||
      (e.which > 90 && e.which < 97) ||
      e.which > 122) {
      if (!!this.allowspecialChar && !this.allowspecialChar.includes(e.which) && this.disabledMetaFields.indexOf('blockspecialchar') == -1) {
        e.preventDefault();
      }
    }
  }

  filterAutoCompleteUp(event, model) {
    if (event.keyCode !== 9 && event.keyCode !== 27 && event.key !== 'Enter' && event.keyCode !== 38 && event.keyCode !== 40) {
      this.currentSelection = 0;
      if (model === 'category') {
        if (this.inside == 'category') {
          if (this.categoryQuery.length > 0) {
            this.filteredCategorySuggestion = this.videoMasterdata.categories.filter(function (el) {
              return el.key.toLowerCase().indexOf(this.categoryQuery.toLowerCase()) > -1;
            }.bind(this));
          } else {
            this.filteredCategorySuggestion = this.videoMasterdata.categories;
          }
        } else {
          this.filteredCategorySuggestion = [];
        }
      } else if (model === 'language') {
        if (this.inside == 'language') {
          if (this.languageQuery.length > 0) {
            this.filteredLanguageSuggestion = this.videoMasterdata.languages.filter(function (el) {
              return el.key.toLowerCase().indexOf(this.languageQuery.toLowerCase()) > -1;
            }.bind(this));
          } else {
            this.filteredLanguageSuggestion = this.videoMasterdata.languages;
          }
        } else {
          this.filteredLanguageSuggestion = [];
        }
      } else if (model === 'genre') {
        if (this.inside == 'genre') {
          if (this.genreQuery.length > 0) {
            this.filteredGenreSuggestion = this.videoMasterdata.genres.filter(function (el) {
              return el.key.toLowerCase().indexOf(this.genreQuery.toLowerCase()) > -1;
            }.bind(this));
          } else {
            this.filteredGenreSuggestion = this.videoMasterdata.genres;
          }
        } else {
          this.filteredGenreSuggestion = [];
        }
      } else if (model === 'subGenre') {
        if (this.inside == 'subGenre' && this.videoMetadata.videoGenre && this.videoMasterdata.subGenres[this.videoMetadata.videoGenre.toString()]) {
          if (this.subGenreQuery.length > 0) {
            this.filteredSubGenreSuggestion = this.videoMasterdata.subGenres[this.videoMetadata.videoGenre.toString()].filter(function (el) {
              return el.key.toLowerCase().indexOf(this.subGenreQuery.toLowerCase()) > -1;
            }.bind(this));
          } else {
            this.filteredSubGenreSuggestion = this.videoMasterdata.subGenres[this.videoMetadata.videoGenre.toString()];
          }
        } else {
          this.filteredSubGenreSuggestion = [];
        }
      } else if (model === 'pChannel') {
        if (this.inside == 'pChannel') {
          if (this.pChannelQuery.length > 0) {
            //this.filteredpChannelSuggestion = this.videoMasterdata.channels.filter(function (el) {
            this.filteredpChannelSuggestion = this.primaryChannels.filter(function (el) {
              return el.key.toLowerCase().indexOf(this.pChannelQuery.toLowerCase()) > -1;
            }.bind(this));
          } else {
            //this.filteredpChannelSuggestion = this.videoMasterdata.channels;
            this.filteredpChannelSuggestion = this.primaryChannels;
          }
        } else {
          this.filteredpChannelSuggestion = [];
        }
      } else if (model === 'sChannel') {
        if (this.inside == 'sChannel') {
          if (this.sChannelQuery.length > 0) {
            //this.filteredpChannelSuggestion = this.videoMasterdata.channels.filter(function (el) {
            this.filteredsChannelSuggestion = this.secondaryChannels.filter(function (el) {
              return el.key.toLowerCase().indexOf(this.sChannelQuery.toLowerCase()) > -1;
            }.bind(this));
          } else {
            //this.filteredpChannelSuggestion = this.videoMasterdata.channels;
            this.filteredsChannelSuggestion = this.secondaryChannels;
          }
        } else {
          this.filteredsChannelSuggestion = [];
        }
      } else if (model === 'playlist') {
        if (this.inside == 'playlist') {
          if (this.playListQuery.length > 0) {
            this.filteredsPlaylistSuggestion = this.playListSuggestion.filter(function (el) {
              return el.key.toLowerCase().indexOf(this.playListQuery.toLowerCase()) > -1;
            }.bind(this));
          } else {
            this.filteredsPlaylistSuggestion = this.playListSuggestion;
          }
        } else {
          this.filteredsPlaylistSuggestion = [];
        }
      }

    }
    return true;
  }

  filterAutoCompleteDown(event, model) {
    if (event.key === 'Enter') {
      // this.inside = '';
      if (model === 'category') {
        this.selectAutoComplete(model, this.filteredCategorySuggestion[this.currentSelection]);
      } else if (model === 'language') {
        this.selectAutoComplete(model, this.filteredLanguageSuggestion[this.currentSelection]);
      } else if (model === 'genre') {
        this.selectAutoComplete(model, this.filteredGenreSuggestion[this.currentSelection]);
      } else if (model === 'subGenre') {
        this.selectAutoComplete(model, this.filteredSubGenreSuggestion[this.currentSelection]);
      } else if (model === 'pChannel') {
        this.selectAutoComplete(model, this.filteredpChannelSuggestion[this.currentSelection]);
      } else if (model === 'sChannel') {
        this.selectAutoComplete(model, this.filteredsChannelSuggestion[this.currentSelection]);
      }
      else if (model === 'playlist') {
        this.selectAutoComplete(model, this.filteredsPlaylistSuggestion[this.currentSelection]);
      }
    } else if (event.keyCode === 40) {
      event.preventDefault();
      if (model === 'category' && this.currentSelection < (this.filteredCategorySuggestion.length - 1)) {
        this.currentSelection += 1;
        this.categoryList.nativeElement.scrollBy(0, 23);
      } else if (model === 'language' && this.currentSelection < (this.filteredLanguageSuggestion.length - 1)) {
        this.currentSelection += 1;
        this.languageList.nativeElement.scrollBy(0, 23);
      } else if (model === 'genre' && this.currentSelection < (this.filteredGenreSuggestion.length - 1)) {
        this.currentSelection += 1;
        this.genreList.nativeElement.scrollBy(0, 23);
      } else if (model === 'subGenre' && this.currentSelection < (this.filteredSubGenreSuggestion.length - 1)) {
        this.currentSelection += 1;
        this.subGenreList.nativeElement.scrollBy(0, 23);
      } else if (model === 'pChannel' && this.currentSelection < (this.filteredpChannelSuggestion.length - 1)) {
        this.currentSelection += 1;
        this.pChannelList.nativeElement.scrollBy(0, 23);
      } else if (model === 'sChannel' && this.currentSelection < (this.filteredsChannelSuggestion.length - 1)) {
        this.currentSelection += 1;
        this.sChannelList.nativeElement.scrollBy(0, 23);
      } else if (model === 'playlist' && this.currentSelection < (this.filteredsPlaylistSuggestion.length - 1)) {
        this.currentSelection += 1;
        this.playList.nativeElement.scrollBy(0, 23);
      }

      event.stopPropagation();
    } else if (event.keyCode === 38) {
      event.preventDefault();
      if (this.currentSelection > 0) {
        this.currentSelection -= 1;
        if (model === 'category' && this.currentSelection < (this.filteredCategorySuggestion.length - 1)) {
          this.categoryList.nativeElement.scrollBy(0, -23);
        } else if (model === 'language' && this.currentSelection < (this.filteredLanguageSuggestion.length - 1)) {
          this.languageList.nativeElement.scrollBy(0, -23);
        } else if (model === 'genre' && this.currentSelection < (this.filteredGenreSuggestion.length - 1)) {
          this.genreList.nativeElement.scrollBy(0, -23);
        } else if (model === 'subGenre' && this.currentSelection < (this.filteredSubGenreSuggestion.length - 1)) {
          this.subGenreList.nativeElement.scrollBy(0, -23);
        } else if (model === 'pChannel' && this.currentSelection < (this.filteredpChannelSuggestion.length - 1)) {
          this.pChannelList.nativeElement.scrollBy(0, -23);
        } else if (model === 'sChannel' && this.currentSelection < (this.filteredsChannelSuggestion.length - 1)) {
          this.sChannelList.nativeElement.scrollBy(0, -23);
        }
        else if (model === 'playlist' && this.currentSelection < (this.filteredsPlaylistSuggestion.length - 1)) {
          this.playList.nativeElement.scrollBy(0, -23);
        }
      }
      event.stopPropagation();
    }
    else if (event.keyCode === 27) {
      event.preventDefault();
      this.inside = '';
      event.stopPropagation();
    } else if (event.keyCode === 9) {
      this.focusOutSuggest(model);
    }
    return true;
  }

  focusInSuggest(model) {
    this.inside = model;
    this.currentSelection = 0;
    if (model == 'category') {
      // const elem = document.getElementById("categoryField");
      // elem.focus();
      this.filteredCategorySuggestion = this.videoMasterdata.categories;
    } else if (model == 'language') {
      // const elem = document.getElementById("languageField");
      // elem.focus();
      this.filteredLanguageSuggestion = this.videoMasterdata.languages;
    } else if (model == 'genre') {
      // const elem = document.getElementById("genreField");
      // elem.focus();
      this.filteredGenreSuggestion = this.videoMasterdata.genres;
    } else if (model == 'subGenre') {
      // const elem = document.getElementById("subGenreField");
      // elem.focus();
      if (this.videoMetadata.videoGenre && this.videoMasterdata.subGenres[this.videoMetadata.videoGenre.toString()]) {
        this.filteredSubGenreSuggestion = this.videoMasterdata.subGenres[this.videoMetadata.videoGenre.toString()];
      }
      else {
        this.filteredSubGenreSuggestion = [];
      }
    } else if (model == 'pChannel') {
      // const elem = document.getElementById("pChannelField");
      // elem.focus();
      //this.filteredpChannelSuggestion = this.videoMasterdata.channels;
      this.filteredpChannelSuggestion = this.primaryChannels;
    }
    else if (model == 'sChannel') {
      // const elem = document.getElementById("sChannelField");
      // elem.focus();
      //this.filteredpChannelSuggestion = this.videoMasterdata.channels;
      this.filteredsChannelSuggestion = this.secondaryChannels;
    }
    else if (model == 'playlist') {
      this.filteredsPlaylistSuggestion = this.playListSuggestion;
    }
  }

  selectAutoComplete(model, item) {
    this.inside = '';
    if (model == 'category') {
      this.categoryQuery = item.key;
      this.videoMetadata.videoCategory = item.value;
      this.filteredCategorySuggestion = [];
    } else if (model == 'language') {
      this.languageQuery = item.key;
      this.videoMetadata.videoLanguage = item.value;
      this.filteredLanguageSuggestion = [];
    } else if (model == 'genre') {
      this.genreQuery = item.key;
      this.videoMetadata.videoGenre = item.value;
      this.filteredGenreSuggestion = [];
      this.subGenreQuery = '';
      this.filteredSubGenreSuggestion = [];
      this.videoMetadata.videoSubGenre = null;
    } else if (model == 'subGenre') {
      this.subGenreQuery = item.key;
      this.videoMetadata.videoSubGenre = item.value;
      this.filteredSubGenreSuggestion = [];
    } else if (model == 'pChannel') {
      this.pChannelQuery = item.key;
      this.videoMetadata.primaryChannel = item.value;
      this.filteredpChannelSuggestion = [];
      this.secondaryChannels = [];
      this.secondaryChannels = this.videoMasterdata.channels.filter(function (el) {
        return el.key.toLowerCase().indexOf(this.pChannelQuery.toLowerCase()) < 0;
      }.bind(this));
      if (this.primaryYTChannelId !== item.value) {
        this.selectedPlaylistChannels = [];
        this.videoMetadata.playlists = [];
        for (const [key, value] of Object.entries(this.playlistChannels)) {
          if (key === item.value) {
            this.playListSuggestion = value;
          }
        }
      }
      this.primaryYTChannelId = item.value;
      // this.videoMasterdata.channels.forEach(el=>{
      //   if(el.key.toLowerCase().indexOf(this.pChannelQuery.toLowerCase()) < 0)
      //   {
      //     //this.secondaryChannels.push({'itemName':el.key,'id':el.value});
      //     this.secondaryChannels.push(el.key);
      //   }
      // })
    } else if (model == 'sChannel') {
      // this.sChannelQuery = item.key;
      // this.videoMetadata.secondaryChannels = item.value;
      if (this.selectedSecondaryChannelValues.indexOf(item.value) > -1) {
        this.sChannelQuery = item.key;
        this.snotify.info("channel already added");
      } else {
        this.sChannelQuery = item.key;
        this.selectedSecondaryChannels.push(item);
        this.selectedSecondaryChannelValues.push(item.value);
        this.videoMetadata.secondaryChannels = this.selectedSecondaryChannelValues;
        this.filteredsChannelSuggestion = [];
        this.primaryChannels = this.primaryChannels.filter(function (el) {
          return el.key.toLowerCase().indexOf(this.sChannelQuery.toLowerCase()) < 0;
        }.bind(this))
      }
      this.sChannelQuery = '';
      // this.primaryChannel = [];
      // this.videoMasterdata.channels.forEach(el=>{
      //   if(el.key.toLowerCase().indexOf(this.pChannelQuery.toLowerCase()) < 0)
      //   {
      //     //this.secondaryChannels.push({'itemName':el.key,'id':el.value});
      //     this.secondaryChannels.push(el.key);
      //   }
      // })
    } else if (model == 'playlist') {
      if (this.selectedPlayListChannelValues.indexOf(item.value) > -1) {
        this.playListQuery = item.key;
        this.snotify.info("playlist already added");
      } else {
        this.playListQuery = item.key;
        this.selectedPlaylistChannels.push(item);
        this.selectedPlayListChannelValues.push(item.value);
        this.videoMetadata.playlists = this.selectedPlayListChannelValues;
        this.filteredsPlaylistSuggestion = [];
      }
      this.playListQuery = '';
    }
  }

  getNewTopicToAdd(event) {
    console.log(event);
    this.videoMetadata.topics = event;
  }

  getSChannels(event) {
    console.log(event);
    this.videoMetadata.secondaryChannels = event;
  }

  focusOutSuggest(model) {
    this.inside = '';
    if (model == 'category') {
      this.filteredCategorySuggestion = [];
    } else if (model == 'language') {
      this.filteredLanguageSuggestion = [];
    } else if (model == 'genre') {
      this.filteredGenreSuggestion = [];
    } else if (model == 'subGenre') {
      this.filteredSubGenreSuggestion = [];
    } else if (model == 'pChannel') {
      this.filteredpChannelSuggestion = [];
    } else if (model == 'sChannel') {
      this.filteredsChannelSuggestion = [];
    } else if (model == 'playlist') {
      this.filteredsPlaylistSuggestion = [];
    }
  }

  closeDropdown(event) {
    console.log(event);
    if (event.relatedTarget && event.relatedTarget.id) {
      if (this.inside == 'category' && event.relatedTarget.id.includes("categoryDropdown")) {
        event.relatedTarget.click();
      } else if (this.inside == 'language' && event.relatedTarget.id.includes("languageDropdown")) {
        event.relatedTarget.click();
      } else if (this.inside == 'genre' && event.relatedTarget.id.includes("genreDropdown")) {
        event.relatedTarget.click();
      } else if (this.inside == 'subGenre' && event.relatedTarget.id.includes("subGenreDropdown")) {
        event.relatedTarget.click();
      } else if (this.inside == 'pChannel' && event.relatedTarget.id.includes("pChannelDropdown")) {
        event.relatedTarget.click();
      } else if (this.inside == 'sChannel' && event.relatedTarget.id.includes("sChannelDropdown")) {
        event.relatedTarget.click();
      } else if (this.inside == 'playlist' && event.relatedTarget.id.includes("playListDropdown")) {
        event.relatedTarget.click();
      }
      else {
        this.resetFilteredData();
        if (this.inside == 'sChannel') {
          this.sChannelQuery = '';
        }
        if (this.inside == 'playlist') {
          this.playListQuery = '';
        }
        this.inside = '';
      }
    }
    else {
      this.resetFilteredData();
      if (this.inside == 'sChannel') {
        this.sChannelQuery = '';
      }
      if (this.inside == 'playlist') {
        this.playListQuery = '';
      }
      this.inside = ''
    }
  }

  openDropdown(event) {
    console.log(event);
  }

  deleteSChannel(index) {
    let channel = this.selectedSecondaryChannels[index];
    this.primaryChannels.push(channel);
    this.selectedSecondaryChannels.splice(index, 1);
    this.selectedSecondaryChannelValues.splice(index, 1);
    this.videoMetadata.secondaryChannels = this.selectedSecondaryChannelValues;
  }

  deletePlayList(index) {
    this.selectedPlaylistChannels.splice(index, 1);
    this.selectedPlayListChannelValues.splice(index, 1);
    this.videoMetadata.playlists = this.selectedPlayListChannelValues;
  }

  onVideoFileChange(event, type) {
    if (event.target.files && event.target.files.length > 0) {
      let tempFile = <File>event.target.files[0];
      if (type == 'longVideo') {
        //this.selectedLongVideoFile = <File>event.target.files[0];
        //if ((this.selectedLongVideoFile.size / 1000000) > 11) {
        if ((tempFile.size / 1000000) > this.videoSize) {
          if (this.selectedLongVideoFile == null) {
            this.longVideo.nativeElement.value = '';
          }
          this.snotify.error('Video size exceeds ' + this.videoSize + 'MB', '', this.sharedService.getConfig(false));
        } else if(this.checkSpecialChars(tempFile.name.slice(0,tempFile.name.lastIndexOf('.')))) {
          if (this.selectedLongVideoFile == null) {
            this.longVideo.nativeElement.value = '';
          }
        } 
        else {
          this.selectedLongVideoFile = tempFile;
          //this.sharedService.sendData('publish_disable|false');
          const reader = new FileReader();
          reader.onload = (e: any) => {
            this.videoSrc = e.target.result;
            if (this.videoCms != null && this.videoCms.primaryYoutubeVideo == null) {
              this.sharedService.sendData('saves3_disable|false');
            }
          };
          reader.readAsDataURL(event.target.files[0]);
        }
      }
      else if (type == 'shortVideo') {
        // this.selectedShortVideoFile = <File>event.target.files[0];
        // if ((this.selectedShortVideoFile.size / 1000000) > 11) {
        if ((tempFile.size / 1000000) > 11) {
          if (this.selectedShortVideoFile == null) {
            this.shortVideo.nativeElement.value = '';
          }
          this.snotify.error('Video size exceeds 12 MB', '', this.sharedService.getConfig(false));
        }
        else {
          this.selectedShortVideoFile = tempFile;
        }
      }
    }
  }


  onFileChange(event) {
    if (event.target.files && event.target.files.length > 0) {
      //this.selectedThumbnailFile = <File>event.target.files[0];
      //if ((this.selectedThumbnailFile.size / 1000000) > 11) {
      let tempFile = <File>event.target.files[0];
      if ((tempFile.size / 1000000) > this.imageSize) {
        if (this.selectedThumbnailFile == null) {
          this.thumbnailImage.nativeElement.value = '';
        }
        this.snotify.error('Image size exceeds ' + this.imageSize + 'MB', '', this.sharedService.getConfig(false));
      } else if(this.checkSpecialChars(tempFile.name.slice(0,tempFile.name.lastIndexOf('.')))) {
        if (this.selectedThumbnailFile == null) {
          this.thumbnailImage.nativeElement.value = '';
        }
      } else {
        this.selectedThumbnailFile = tempFile;
        //this.sharedService.sendData('publish_disable|false');
        if(this.videoCms != null && this.videoCms.primaryYoutubeVideo == null)
          {
            this.sharedService.sendData('saves3_disable|false');
          }
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.imageSrc = e.target.result;
        };
        reader.readAsDataURL(event.target.files[0]);
      }
    }
  }

  setRequestBody() {
    if (this.selectedLongVideoFile != null) {
      this.requestBody.append('longfile', this.selectedLongVideoFile, this.selectedLongVideoFile.name);
    }
    if (this.selectedShortVideoFile != null) {
      this.requestBody.append('shortfile', this.selectedShortVideoFile, this.selectedShortVideoFile.name);
    }
    if (this.selectedThumbnailFile != null) {
      this.requestBody.append('thumbnail', this.selectedThumbnailFile, this.selectedThumbnailFile.name);
    }
    if (this.id != null) {
      this.requestBody.append('id', this.id)
    }
    if (this.videoMetadata != null && (this.createMode || this.editMode)) {
      this.requestBody.append('metadata', JSON.stringify(this.videoMetadata));
    }
    // else if (this.videoMetadata != null && this.editMode && !isEqual(this.videoMetadata, this.savedVideoMetadata)) {
    //   this.requestBody.append('metadata', JSON.stringify(this.videoMetadata))
    // }
  }

  setUnlisted(value) {
    if (value.target.checked) {
      this.videoMetadata.unlisted = true;
    } else {
      this.videoMetadata.unlisted = false;
    }
  }

  checkSpecialChars(imageFileName) {
    let regex = new RegExp(/[^a-zA-z0-9-_\s]+/g);
    let m;
    m = regex.exec(imageFileName);
    if (m) {
      imageFileName = imageFileName.replace(regex, '');
      this.snotify.error('Special Chars not allowed in file name', '', this.sharedService.getConfig(false));
      return true;
    }
    if (imageFileName.length > 50) {
      this.snotify.error('File Name should be less than 50 characters', '', this.sharedService.getConfig(false));
      imageFileName = imageFileName.slice(0, 50);
      return true;
    }
    return false;
  }
  googleAnalytics(eventCategory,eventAction,eventLabel,eventValue){
    this.gaService.gaEventView(eventCategory,eventAction,eventLabel,eventValue)
   }

   videoButtonsMethod(method)
   {
    this.snotify.clear();
    this[method]();
   }

   deleteCurrentVideo() {
    if (this.id != null) {
      this.revertListFlag = false;
      this.isLoading = true;
      this.http.put(this.config.get('product').videoCmsUrl
      + "/api/cms/video/delete/" + this.id, null).subscribe((response: CmsVideos) => {
        this.isLoading = false;
        if (response && response.isDeleted == 1) {
          this.snotify.info("Video deleted successfully");
          this.router.navigate(['/dash/video-cms-list']);
        } else {
          this.snotify.error('Failed to delete video', '', this.sharedService.getConfig(false));
        }
      }, (error) => {
        //console.log(error);
        this.isLoading = false;
        if(error.status === 400 && error && error.error && error.error.errorMessage)
        {
          // this.snotify.error(error.error.errorMessage, '', this.sharedService.getConfig(false));
        }
        else{
          this.snotify.error('Error While deleting video', '', this.sharedService.getConfig(false));
        }
      });
    }
  }
}
